<template>
  <div class="card-parcelas-pedido-andamento">
    <g-card class="card-consultas-carta-header" :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
          <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
          />
          <div class="titulo-detalhes-cabecalho"> Parcelas do Pedido </div>
        </div>
        
        <div class="header-icons" v-tooltip="'Abrir PDF'">
          <g-button
            @click="imprimir()"
            class=""
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="icone_print.svg"
          />
        </div>
      </div>

      <div class="conteudo-card-parcelas-pedido-andamento espacamento-detalhes">
        <div class="grupo-dados-gerais">
          <div class="dados-parcela-titulo titulo-grupo-detalhes"> Dados Gerais </div>

          <div class="grupo-dados-parcela">
            <div class="dados-parcela-cliente">
              <div class="titulo-conteudo-detalhes"> Pedido </div>
              <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoPedido}} </div>
            </div>

            <div class="dados-parcela-unidade">
              <div class="titulo-conteudo-detalhes"> Orçamento </div>
              <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoOrcamento}} </div>
            </div>

            <div class="dados-parcela-tipo">
              <div class="titulo-conteudo-detalhes"> Tipo </div>
              <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.TipoPedidoTexto}} </div>
            </div>

            <div class="dados-parcela-cliente">
              <div class="titulo-conteudo-detalhes"> Cliente / CNPJ </div>
              <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoCliente}} - {{this.detalhesDoPedidoFluxo.NomeFantasia}} / {{this.detalhesDoPedidoFluxo.CnpjFormatado }} </div>
            </div>

            <div class="dados-parcela-representante">
              <div class="titulo-conteudo-detalhes"> Representante </div>
              <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.NomeRepresentante}} </div>
            </div>

            <div class="dados-parcela-unidade">
              <div class="titulo-conteudo-detalhes"> Unidade </div>
              <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.NomeEmpresa}} </div>
            </div>

            <div class="dados-parcela-cv">
              <div class="titulo-conteudo-detalhes"> CV </div>
              <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CurvaClienteTexto}} </div>
            </div>
          </div>
        </div>

        <div class="content-parcelas">
          <div class="titulo-grupo-detalhes"> Parcelas </div>

          <div class="grupo-parcelas">
            <div class="parcelas" v-for="(obj, index) in this.parcelasInfo" :key="index">
              <div class="numero-parcela-botoes">
                <div class="numero-parcela"> {{index + 1}}º Parcela </div>
                <div class="btns-acoes-parcelas">
                  <!-- <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="notasFiscaisRota(this.codigoPedido, obj.numeroParcela)"
                  >
                    <i class="pi pi-file"></i>
                  </g-button> -->

                  <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="observacoesRota(obj.numeroParcela)"
                  >
                    <i class="pi pi-book"></i>
                  </g-button>

                  <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="instrucoesCarregamentoRota(obj.numeroParcela)"
                  >
                    <i class="pi pi-car"></i>
                  </g-button>

                  <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="historicoRota(obj.id, obj.numeroParcela)"
                  >
                    <i class="pi pi-clock"></i>
                  </g-button>
                </div>
              </div>
              
              <div class="conteudo-parcelas">
                <div class="data-carregamento">
                  <div class="titulo-conteudo-detalhes"> Data Carregamento </div>
                  <div class="label-conteudo">{{ obj.dataCarregamentoFormatada || 'Sem Dados'}}</div>
                </div>

                <div class="quantidade">
                  <div class="titulo-conteudo-detalhes"> Quantidade </div>
                  <div class="label-conteudo">{{ formataDecimal(obj.quantidadePedidoParcela) }}</div>
                </div>

                <div class="data-conf-carregamento">
                  <div class="titulo-conteudo-detalhes"> Data Conf. Carregamento </div>
                  <div class="label-conteudo">{{ obj.dataPedidoParcelaFormatada }}</div>
                </div>

                <div class="qtde-produzida">
                  <div class="titulo-conteudo-detalhes"> Quantidade Produzida </div>
                  <div class="label-conteudo">{{ formataDecimal(obj.quantidadeProduzida) }}</div>
                </div>

                <div class="qtde-expedida">
                  <div class="titulo-conteudo-detalhes"> Quantidade Expedida </div>
                  <div class="label-conteudo">{{ formataDecimal(obj.quantidadeExpandida) }}</div>
                </div>

                <div class="parcela">
                  <div class="titulo-conteudo-detalhes"> Parcela </div>
                  <div class="label-conteudo">{{ obj.numeroParcelaDias }}</div>
                </div>

                <div class="agua-liberacao-producao">
                  <div class="titulo-conteudo-detalhes"> Aguardando Liberação para Produzir </div>
                  <div class="label-conteudo">{{ obj.liberadoParaProduzir == false ? 'Não' : 'Sim' }}</div>
                </div>

                <div class="dias-prorrogados">
                  <div class="titulo-conteudo-detalhes"> Dias Prorrogados </div>
                  <div class="label-conteudo">{{ obj.numeroParcelaDias }}</div>
                </div>

                <div class="indicador">
                  <div class="titulo-conteudo-detalhes"> Indicador </div>
                  <div class="label-conteudo">{{ obj.indicadorTexto || 'Não possui' }}</div>
                </div>

                <div class="data-base">
                  <div class="titulo-conteudo-detalhes"> Data Base </div>
                  <div class="label-conteudo">{{ obj.dataBasePedidoParcelaFormatada || '-' }}</div>
                </div>

                <div class="ordem-compra">
                  <div class="titulo-conteudo-detalhes"> Ordem de Compra </div>
                  <div class="label-conteudo">{{ obj.numeroOrdemDeCompra || 'Não Possui' }}</div>
                </div>

                <div class="componente">
                  <div class="titulo-conteudo-detalhes"> Componente </div>
                  <div class="label-conteudo" v-for="(componente, index) in componentePedidoParcelaArray" :key="index"
                  >
                    {{componente.componenteTipoTexto || 'Não Possui'}}
                  </div>
                </div>

                <div class="fase-producao">
                  <div class="titulo-conteudo-detalhes"> Fase de Produção </div>
                  <div class="label-conteudo" v-for="(componente, index) in componentePedidoParcelaArray" :key="index"
                  >
                    {{componente.descricaoFaseProduto || 'Não Possui'}}
                  </div>
                </div>

                <div class="obs-parcelas">
                  <div class="titulo-conteudo-detalhes"> Observações sobre as parcelas </div>
                  <div class="label-conteudo">{{obj.descricaoParcela || 'Não Possui'}}</div>
                </div>
              </div>
            </div>
          </div>        
        </div>
      </div>
    </g-card>
  </div>

  <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
    <div class="render" v-if="renderiza">
      <PedidoEmAndamentoPDF 
        :tituloDetalhes="false" 
        v-on:termino="gerarPdf" 
        :pedidoSelecionado="PedidoId"
        @podeGerarPDF="podeGerarPdf = $event"
      />
    </div>
  </g-pdf>
</template>

<script>
import ParcelasPedidosCanceladosLiquidados from './ParcelasPedidosCanceladosLiquidados.js'
export default ParcelasPedidosCanceladosLiquidados
</script>

<style scoped>
.grupo-parcelas {
  margin-top: 1.5rem;
}

.numero-parcela-botoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.btns-acoes-parcelas {
  display: flex;
  align-items: center;
  column-gap: 0.3rem;
}

.conteudo-parcelas {
	padding: 1rem 1.5rem 0.3rem;
	border-radius: 0.5rem;
	background-color: #F9F9F9;
  border-left: 5px solid #e7ae4c98;
	margin-bottom: 3rem;
}

.numero-parcela {
  color: #4D4D4D;
  text-align: justify;
  font-size: 1.1rem;
  font-family: 'MontSerrat';
  font-weight: 600;
}

.content-parcelas {
  margin-top: 1.5rem;
}

@media(min-width:310px) {
  .grupo-dados-parcela{
    display: grid;
    grid-template-columns: repeat(1, minmax(4em, 1fr));
    grid-template-rows: repeat(7, auto);
    column-gap: 3%;
  }
}


@media(min-width:368px) {}


@media(min-width:600px) {
  .grupo-dados-parcela{
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
  }

  .conteudo-parcelas {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem 1rem;
  }

  .obs-parcelas {
    grid-column: span 2;
  }
}


@media(min-width:801px) {
  .grupo-dados-parcela{
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
    column-gap: 3%;
  }

  .conteudo-parcelas {
    grid-template-columns: repeat(3, 1fr);
  }

  .obs-parcelas {
    grid-column: span 3;
  }
}


@media(min-width:1025px) {
  .grupo-dados-parcela {
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
    column-gap: 3%;
  }
}


@media(min-width:1285px) {
  .grupo-dados-parcela {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

@media(min-width:1500px) {
  .conteudo-parcelas {
    grid-template-columns: repeat(4, 1fr);
  }

  .obs-parcelas {
    grid-column: span 4;
  }
}

@media(min-width:1800px) {
  .conteudo-parcelas {
    grid-template-columns: repeat(5, 1fr);
  }

  .obs-parcelas {
    grid-column: span 5;
  }
}

</style>